var _objectAssign = /*#__PURE__*/require('./_objectAssign');

module.exports = typeof Object.assign === 'function' ? Object.assign : _objectAssign;


//////////////////
// WEBPACK FOOTER
// ./~/ramda/src/internal/_assign.js
// module id = 377
// module chunks = 0